import React from 'react'
import {makeStyles } from '@material-ui/core'
import SectionA from './sections/SectionA/SectionA';
import SectionB from './sections/SectionB/SectionB';
import SectionC from './sections/SectionC/SectionC';
import SectionD from './sections/SectionD/SectionD';
import SectionE from './sections/SectionE/SectionE';
import NavBar from './components/NavBar/NavBar';
import useMainView from './useMainView';
import SectionF from './sections/sectionF/SectionF';
import ContactView from '../ContactView/ContactView';

const MainView = ({language, history, topic_modal, onChangeModal}) =>{

  const classes = useStyles()
  const {scroll_position, actions, modals} = useMainView({})

  return(
    <div className={classes.root}>
      {/* {!modals.internal_modal ? <NavBar history={history} /> : null} */}
      <SectionA language={language} scroll_position={scroll_position} offset={0} actions={actions}/>
      <SectionB language={language} scroll_position={scroll_position} offset={7000} actions={actions}/>
      <SectionC onChangeValueModal={onChangeModal} language={language} scroll_position={scroll_position} offset={14800} />
      <SectionD language={language} scroll_position={scroll_position} offset={19300} actions={actions}/>
      <SectionE onChangeModal={onChangeModal} language={language} scroll_position={scroll_position} offset={25500} actions={actions}/>
      <SectionF language={language} scroll_position={scroll_position} offset={27500} actions={actions}/>
    </div>
  )

}


const useStyles = makeStyles(theme => ({
  fab:{
    top:33,
    right:77,
    position:'fixed',
    background:theme.palette.primary.main,
    color:'white',
    zIndex:1,
    '&:hover':{
      background:theme.palette.primary.main,
    }
  }
}))

export default MainView